import updateMutation from './util/updateMutation';
import rangeSort from './util/rangeSort';

// if we need to convert to certain entities for safety we can do it here :) 
const ENTITY_MAP = {
  '&': '&',
};

export default block => {
  const blockText = [...block.text];

  let entities = block.entityRanges.sort(rangeSort);
  let styles = block.inlineStyleRanges.sort(rangeSort);
  let resultText = '';

  for (let index = 0; index < blockText.length; index++) {
    const char = blockText[index];

    if (ENTITY_MAP[char] !== undefined) {
      const encoded = ENTITY_MAP[char];
      const resultIndex = [...resultText].length;
      resultText += encoded;

      const updateForChar = mutation => {
        return updateMutation(
          mutation,
          resultIndex,
          char.length,
          encoded.length,
          0,
          0
        );
      };

      entities = entities.map(updateForChar);
      styles = styles.map(updateForChar);
    } else {
      resultText += char;
    }
  }

  return Object.assign({}, block, {
    text: resultText,
    inlineStyleRanges: styles,
    entityRanges: entities,
  });
};
